/**
 * Support Models
 * Data models for support tickets feature
 */

export type TicketStatus = 'open' | 'in-progress' | 'resolved' | 'closed';
export type TicketPriority = 'critical' | 'high' | 'medium' | 'low';
export type TicketCategory = 'technical' | 'billing' | 'feature' | 'general' | 'api' | 'template';

export interface Ticket {
  id: string;
  ticketId: string;
  subject: string;
  description: string;
  category: TicketCategory;
  priority: TicketPriority;
  status: TicketStatus;
  createdAt: string;
  updatedAt: string;
  attachments?: TicketAttachment[];
  messages?: TicketMessage[];
}

export interface TicketAttachment {
  id: string;
  fileName: string;
  fileSize: number;
  fileType: string;
  url: string;
}

export interface TicketMessage {
  id: string;
  content: string;
  createdAt: string;
  isStaffReply: boolean;
  author?: {
    name: string;
    avatar?: string;
    role?: string;
  };
  attachments?: TicketAttachment[];
}

export interface TicketFilters {
  search: string;
  status: string;
  priority: string;
  category: string;
}

export interface TicketStats {
  totalTickets: number;
  openTickets: number;
  resolvedTickets: number;
  avgResponseTime: string;
  openChange: number;
  resolvedChange: number;
  totalChange: number;
  responseTimeChange: number;
}

export interface CreateTicketRequest {
  subject: string;
  description: string;
  category: TicketCategory;
  priority: TicketPriority;
  attachments?: File[];
}

export interface SupportState {
  tickets: Ticket[];
  selectedTicket: Ticket | null;
  stats: TicketStats | null;
  filters: TicketFilters;
  totalTickets: number;
  currentPage: number;
  pageSize: number;
  loading: boolean;
  submitting: boolean;
  error: string | null;
  successMessage: string | null;
}

export const initialSupportState: SupportState = {
  tickets: [],
  selectedTicket: null,
  stats: null,
  filters: {
    search: '',
    status: '',
    priority: '',
    category: ''
  },
  totalTickets: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  submitting: false,
  error: null,
  successMessage: null
};

